import React from 'react'
import {Button, Card, CardHeader, CardText, CardTitle, Col, Media, Table,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import ErrorModal from "../Alerts/ErrorModal";
import {student_strings} from "../../translations/student_translations";
import reportApiService from "../../api/report-api-service";
import CardImg from "reactstrap/lib/CardImg";
import CardBody from "reactstrap/lib/CardBody";
import placeholderHelper from "../../helpers/PlaceholderHelper";
import dateHelpers from "../../helpers/DateHelper";
import BusinessDataTableRow from "../Tables/BusinessDataTableRow";
import Maps from "../../views/examples/Maps";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);
let studentStrings = new LocalizedStrings(student_strings);

const propTypes = {};

export default class UserData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: null,
            allBusinesses: null,
            type: "exp_subscr",
            // type: "map",
            isLoading: false,
        };
    }

    setMaster = this.setMaster.bind(this)

    componentDidMount() {
        this.getData(this.state.type)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleChange(event) {
    }

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showUserModal === true &&
                    this.renderUserModal()
                    }

                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Col lg="12">
                        <Card className="bg-default shadow">
                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent">
                                    {this.state.users &&
                                    <Row>
                                        <h2 className="text-white mb-0">ACTIVE
                                            USERS {this.state.users ? " (" + this.state.users.length + ")" : ""}</h2>
                                    </Row>
                                    }

                                    {this.state.allBusinesses &&
                                    <Row>
                                        <h2 className="text-white mb-0">ALL
                                            BUSINESSES {this.state.allBusinesses ? " (" + this.state.allBusinesses.length + ")" : ""}</h2>
                                    </Row>
                                    }

                                    <Row>
                                        <Button
                                            color={this.state.type === "cards" ? "success" : "secondary"}
                                            href="#pablo"
                                            size="sm"
                                            onClick={e => this.setActiveOnly(e)}
                                        >
                                            ACTIVE
                                        </Button>

                                        <Button
                                            color={this.state.type === "all" ? "success" : "secondary"}
                                            href="#pablo"
                                            size="sm"
                                            onClick={e => this.setAllBusinesses(e)}
                                        >
                                            ALL
                                        </Button>

                                        <Button
                                            color={this.state.type === "today" ? "success" : "secondary"}
                                            href="#pablo"
                                            size="sm"
                                            onClick={e => this.setAllBusinesses(e, "today")}
                                        >
                                            VISITED TODAY
                                        </Button>

                                        <Button
                                            color={this.state.type === "exp_subscr" ? "success" : "secondary"}
                                            href="#pablo"
                                            size="sm"
                                            onClick={e => this.setAllBusinesses(e, "exp_subscr")}
                                        >
                                            EXPIRING PREMIUM
                                        </Button>

                                        <Button
                                            color={this.state.type == "map" ? "success" : "secondary"}
                                            href="#pablo"
                                            size="sm"
                                            onClick={e => this.setAllBusinesses(e, "map")}
                                        >
                                            MAP
                                        </Button>
                                    </Row>

                                </CardHeader>
                                {this.renderView()}
                            </Card>
                        </Card>
                    </Col>
                </>
            </LoadingOverlay>
        )
    }

    renderTable() {
        if (this.state.allBusinesses !== null) {
            return <Table
                className="align-items-center table-dark table-flush"
                responsive
            >
                <tbody>
                {this.state.allBusinesses.map((business, index) => {
                    return (
                        <BusinessDataTableRow user={business} key={business.id}
                                              make_client={this.make_client.bind(this)}
                                              hide={this.hide.bind(this)}
                                              // send_news={this.send_news.bind(this)}
                                              // send_news_082020={this.send_news_082020.bind(this)}
                                              unpublish={this.unpublish.bind(this)}
                                              onUserIdSelected={this.props.onUserIdSelected}
                                              setMaster={this.set_master.bind(this)}
                                              sendTrialExpiresEmail={this.sendTrialExpiresEmail.bind(this)}
                                              endTrial={this.endTrial.bind(this)}
                                              startTrial={this.startTrial.bind(this)}
                        />
                    )
                })}
                </tbody>
            </Table>;
        }
    }

    send_news(id) {
        this.setState({isLoading: true})
        reportApiService.send_web_news(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    send_news_082020(id) {
        this.setState({isLoading: true})
        reportApiService.send_news_082020(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    unpublish(id) {
        this.setState({isLoading: true})
        reportApiService.unpublish(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    make_client(id) {
        this.setState({isLoading: true})
        reportApiService.make_client(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    hide(id) {
        this.setState({isLoading: true})
        reportApiService.hide_business(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    isToday(dateString) {
        const today = dateHelpers.databaseDate(new Date())
        const eventDate = dateHelpers.databaseDate(new Date(dateString))

        return today === eventDate
    }

    renderCards() {
        return (this.state.users || []).map((user, index) => {
            return (<Col lg="4" className="mb-2" key={user.id}>
                <Card style={{width: "100%"}}>
                    <CardImg
                        alt="..."
                        src={user.photo && user.photo.length > 0 ? user.photo : require("assets/img/theme/placeholder.png")}
                        top
                    />
                    <CardBody>
                        <Row>
                            <Col lg="6">
                                <span className="mb-0 text-sm">
                                    <a href="#" onClick={(e) => this.props.onUserIdSelected(e, user.id)}>{user.id}</a>
                                        <CardTitle><b>{user.name}</b></CardTitle>
                                    <a href={user.web}>{user.web}</a>
                                        <p className="mt-0">{user.address}</p>
                                </span>
                            </Col>
                            <Col lg="2">
                                <span className="mb-0 text-sm">
                                    {user.channel === "web" ? (<i className="fas fa-laptop"/>) :
                                        user.channel === "ios" ? (<i className="fas fa-apple-alt"/>) :
                                            user.channel === "android" ? (<i className="fas fa-robot"/>) : <></>}
                                </span>
                            </Col>
                            <Col lg="4">
                                <Media className="align-items-center">
                                    <a
                                        className="avatar mr-3"
                                        onClick={e => e.preventDefault()}
                                    >
                                        <img
                                            alt="..."
                                            style={{objectFit: "cover", imageOrientation: "from-image"}}
                                            src={user.logo ? user.logo : placeholderHelper.randomIcon()}
                                        />
                                    </a>
                                </Media>
                            </Col>
                        </Row>
                        <CardText>
                            <small className="text-gray">{user.description ? user.description.slice(0,50) : ""}</small><br/>
                            <small>Public: {user.public}</small><br/><br/>
                            <small>Students: {user.students_info}</small><br/>
                            <small>Classes: {user.class_info}</small><br/>
                            <small>Tickets: {user.ticket_info}</small><br/><br/>
                            <small>Locale: {user.locale}</small><br/>

                            <small className="mb-0 text-sm">
                                <b>PRO: {user.pro || "?"} since: {user.subscription_created || "?"}</b>
                            </small>

                            <li>Created: {user.user_created || "?"}</li>
                            <b>
                                <li>Last Event: {user.last_event || "?"}</li>
                            </b>
                            <small>{JSON.stringify(user.events)}</small><br/>


                            <small>Team members: {user.sub_users}</small><br/>
                            <small>Timezone: {user.timezone}</small><br/>
                        </CardText>
                        <Button
                            color={this.isToday(user.last_event) ? "success" : "secondary"}
                            href="#pablo"
                            size="sm"
                            onClick={e => this.setMaster(e, user.id)}
                        >
                            Check in
                        </Button>
                    </CardBody>
                </Card>
            </Col>)
        })
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getData(type = this.state.type) {
        if (type === "cards") {
            this.setState({isLoading: true, allBusinesses: null, users: null});
            reportApiService.admin_activeUsers()
                .then(res => {
                    this.setState({
                        users: res,
                        isLoading: false,
                    });
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        } else {
            if (type == "today") {
                this.setState({isLoading: true, allBusinesses: null, users: null});
                reportApiService.admin_all_businesses(true)
                    .then(res => {
                        this.setState({
                            allBusinesses: res,
                            isLoading: false,
                        });
                    })
                    .catch((e) => {
                        this.handleNetworkError(e)
                    });
            } else if (type == "exp_subscr") {
                this.setState({isLoading: true, allBusinesses: null, users: null});
                reportApiService.admin_all_businesses(false, true)
                    .then(res => {
                        this.setState({
                            allBusinesses: res,
                            isLoading: false,
                        });
                    })
                    .catch((e) => {
                        this.handleNetworkError(e)
                    });
            } else if (type == "map") {
                this.setState({isLoading: true, allBusinesses: null, users: null});
                reportApiService.getCoordinates()
                    .then(res => {
                        this.setState({
                            coordinates: res,
                            isLoading: false,
                        });
                    })
                    .catch((e) => {
                        this.handleNetworkError(e)
                    });
            } else {
                this.setState({isLoading: true, allBusinesses: null, users: null});
                reportApiService.admin_all_businesses_new()
                    .then(res => {
                        this.setState({
                            allBusinesses: res,
                            isLoading: false,
                        });
                    })
                    .catch((e) => {
                        this.handleNetworkError(e)
                    });
            }
        }
    }

    setMaster(e, id) {
        e.preventDefault();

        this.setState({isLoading: true})
        reportApiService.admin_sm(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    set_master(id) {
        this.setState({isLoading: true})
        reportApiService.admin_sm(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    sendTrialExpiresEmail(id) {
        this.setState({isLoading: true})
        reportApiService.sendTrialExpiresEmail(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    endTrial(id) {
        this.setState({isLoading: true})
        reportApiService.endTrial(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    startTrial(id) {
        this.setState({isLoading: true})
        reportApiService.startTrial(id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    toggleUserModal = state => {
        this.setState({
            showUserModal: !this.state.showUserModal
        });
    };

    setActiveOnly(e) {
        e.preventDefault();
        this.setState({type: "cards"})
        this.getData("cards")
    }

    setAllBusinesses(e, type = null) {
        e.preventDefault();
        this.setState({type: type || "all"})
        this.getData(type ? type : "all")
    }

    renderMap() {
        return (<Maps coordinates={this.state.coordinates}/>)
    }

    renderView() {
        return(
            <div className="container-fluid">
                {this.state.type == "cards" &&
                <Row>
                    {this.renderCards()}
                </Row>
                }
                {(this.state.type == "all" || this.state.type == "exp_subscr" || this.state.type == "today") &&
                <Row>
                    {this.renderTable()}
                </Row>
                }
                {this.state.type == "map" && this.state.coordinates &&
                <Row>
                    {this.renderMap()}
                </Row>
                }
            </div>
        )
    }
}

UserData.propTypes = propTypes;